module.exports = __webpack_public_path__ + "static/img/ind_ban_02.ed2cceb1.jpeg";